(function () {
  window.__bazzareoScrollRevealLoaded = true;

  // Skip entirely inside the Theme Editor. The editor re-injects a section's markup
  // (fresh DOM nodes) whenever it's selected or a setting changes, and those new nodes
  // are never observed by the IntersectionObserver set up below (which only ever runs
  // once, against the sections present at initial page load) - they'd be stuck at
  // opacity:0 forever, showing as blank placeholder boxes while editing. The entrance
  // animation has no value in the editor anyway, so just don't opt sections into the
  // hidden-until-revealed CSS state when in design mode.
  if (window.Shopify && window.Shopify.designMode) return;

  var mainContent = document.getElementById('MainContent');
  if (!mainContent) return;

  var targets = mainContent.querySelectorAll(':scope > .shopify-section');
  if (!targets.length) return;

  // Only opt sections into the hidden-until-revealed CSS state once we know JS is
  // actually running. If this script fails to load or run for any reason, sections
  // simply render normally instead of staying permanently invisible.
  document.documentElement.classList.add('scroll-reveal-js');

  var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (prefersReduced || !('IntersectionObserver' in window)) {
    targets.forEach(function (el) {
      el.classList.add('is-inview');
    });
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-inview');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.12, rootMargin: '0px 0px -8% 0px' }
  );

  targets.forEach(function (el) {
    observer.observe(el);
  });

  // Safety net: if IntersectionObserver never fires for a section (backgrounded tab,
  // unusual layout, browser quirk), force-reveal everything after a short delay so
  // content can never get stuck invisible.
  window.setTimeout(function () {
    targets.forEach(function (el) {
      el.classList.add('is-inview');
    });
  }, 2500);
})();
